import React from "react";
import { Box, IconButton, Heading } from "@origin-digital/ods-core";
import { IconChevronLeft } from "@origin-digital/ods-icons";
import { useLocation, useNavigate } from "react-router-dom";

export const PageTitleSection = ({ name }: { name: string }) => {
  const location = useLocation();
  const locationBackUrl = location.state?.backUrl || "/";

  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={["medium", "large"]}
      data-role="section"
      id="detail-template-page-title-section"
    >
      {/* Page title */}
      <Box display="flex" gap="medium" alignItems="center">
        <IconButton
          noIconPadding
          aria-label="Go back"
          onClick={() => navigate(locationBackUrl)}
        >
          <IconChevronLeft size="xxsmall" variant="solid" />
        </IconButton>
        <Heading variant="h3">{name}</Heading>
      </Box>
      {/* End Page title */}

      {/* Address will appear here when request is created */}
    </Box>
  );
};
